module.exports = __webpack_public_path__ + "img/ico_earncoins_download@3x.c5e6822f.png";